import { Component, OnInit, Input, OnChanges, OnDestroy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { Subscription } from 'rxjs';
import { FormsTurnsService } from 'src/app/services/turns-services/forms-turns-service/forms-turns.service';

@Component({
  selector: 'app-turns-form-online-show-card',
  templateUrl: './turns-form-online-show-card.component.html',
  styleUrls: ['./turns-form-online-show-card.component.scss']
})
export class TurnsFormOnlineShowCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() form;
  basicDataForm = new FormGroup({
    online: new FormControl(null)
  });
  updateShowOnlineSubscription: Subscription;

  constructor(private formsTurnsService: FormsTurnsService,
              private snackbarService: SnackBarService) { }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.form && this.form.Online) {
      this.resetForm();
    }
  }

  public inputChange() {
    this.submitForm();
  }

  public submitForm() {
    this.updateShowOnlineSubscription = this.formsTurnsService.updateShowOnlineForm(this.form.InternalId, this.basicDataForm.get('online').value).subscribe(
      (res) => {
        this.snackbarService.open(res['message'], 'success');
      },
      (error) => {
        this.snackbarService.open(error['message'], 'error');
      }
    );
  }

  private resetForm() {
    this.basicDataForm.patchValue({
      online: this.form.Online
    });
  }

  ngOnDestroy() {
    if (this.updateShowOnlineSubscription) { this.updateShowOnlineSubscription.unsubscribe(); }
  }
}
